import { api, type ApiResponse } from '../api';
import type { EffectiveEntitlements, SubscriptionSummary } from './types';

export const subscriptionService = {
  async getMine(): Promise<SubscriptionSummary> {
    const response = await api.get<ApiResponse<SubscriptionSummary>>(
      '/subscription/me',
    );
    return response.data.data;
  },

  async getEntitlements(): Promise<EffectiveEntitlements> {
    const response = await api.get<ApiResponse<EffectiveEntitlements>>(
      '/subscription/me/entitlements',
    );
    return response.data.data;
  },
};

